import Head from 'next/head';
import { useSelector } from 'react-redux';
import { NextSeo } from 'next-seo';
import ProdigyContainer from '@cont/Prodigy/ProdigyContainer';
import { fetchTestSeriesData } from '@actions/quizzes';

const TestSeries = () => {
  const data = useSelector(({ quizzes }) => quizzes.testSeries?.aspire || null);
  const { metaData = {} } = data;
  const { title, description, ogImage, twitterOgImage } = metaData;
  return (
    <>
      <NextSeo
        title={title}
        description={description}
        openGraph={{
          title,
          description,
          images: [
            {
              url: ogImage
            }
          ]
        }}
        twitter={{
          images: [{ url: twitterOgImage }]
        }}
      />
      <Head>
        <title>{metaData.title}</title>
      </Head>
      <ProdigyContainer data={data} />
    </>
  );
};

TestSeries.getInitialProps = async ({ store }) => {
  if (!store.getState().quizzes.testSeries?.aspire) {
    await store.dispatch(fetchTestSeriesData('aspire'));
  }
};

TestSeries.pageInfo = {
  name: 'Unacademy Aspire',
  layoutOptions: {
    hideSearch: true,
    hideGoalSelector: true,
    hideLearnerMinutes: true,
    hideNudges: true,
    disableDarkMode: true,
    useFreeLayout: true,
    hideIntercom: true,
    hideFreshbot: true
  }
};

export default TestSeries;
